<template>
  <Row class="detail-content">
    <Row>
      <Col span="5" class="left-label">侵权产品：</Col>
      <Col span="16" class="right-content">{{ caseDetail.tortProduct }}</Col>
    </Row>
    <Row>
      <Col span="5" class="left-label">案由：</Col>
      <Col span="16" class="right-content">{{ caseDetail.reasonName }}</Col>
    </Row>
    <Row>
      <Col span="5" class="left-label">侵权权利：</Col>
      <Col span="16" class="right-content">{{ caseDetail.rightsName }}</Col>
    </Row>
    <Row>
      <Col span="5" class="left-label">对方当事人：</Col>
      <Col span="16" class="right-content">{{ caseDetail.litigantName }}</Col>
    </Row>
    <Row>
      <Col span="5" class="left-label">代理律师：</Col>
      <Col span="16" class="right-content">{{ caseDetail.actingLawyerName }}</Col>
    </Row>
    <Row>
      <Col span="5" class="left-label">诉讼标的：</Col>
      <Col span="16" class="right-content">{{ common.formateNumber(caseDetail.amount) }}</Col>
    </Row>
    <Row>
      <Col span="5" class="left-label">合理支出：</Col>
      <Col span="16" class="right-content">{{ common.formateNumber(caseDetail.reasonable) }}</Col>
    </Row>
    <Row>
      <Col span="5" class="left-label">管辖法院：</Col>
      <Col span="16" class="right-content">{{ caseDetail.courtJurisdiction }}</Col>
    </Row>
    <Row v-for="(item, index) in caseDetail.caseProgramWritList" :key="index">
      <Col span="5" class="left-label">{{ item.name }}：</Col>
      <Col span="16" class="right-content">
        <file-upload :default-list="item.attachmentList || []" :upload-config="{ readOnly: true }" />
      </Col>
    </Row>
    <Row>
      <Col span="5" class="left-label">主体材料：</Col>
      <Col span="16" class="right-content">{{ caseDetail.isMainMaterial ? '有' : '无' }}</Col>
    </Row>
    <Row>
      <Col span="5" class="left-label">加盖私章：</Col>
      <Col span="16" class="right-content">{{ caseDetail.personalSeal ? '是' : '否' }}</Col>
    </Row>
  </Row>
</template>

<script>
export default {
  name: 'EditRecordList',
  props: {
    caseDetail: {
      type: Object
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/civilCase/lawsuitProgramme/lawsuitPlan/editRecordList.vue